import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteStakeholderRequest = {
	stakeholderIds: Array<number>;
};

export const deleteStakeholder = createDeleteEndpoint<DeleteStakeholderRequest>('/api/v3/core/stakeholders');
